/* globals updateEventBind, addQueryParam */
(function () {
	'use strict';

	angular.module('app.dashboard')
		.controller('shortagePoActionsCtrl', shortagePoActionsCtrl);

	function shortagePoActionsCtrl($scope, leanFilterService,
			dashboardFilterInitializationService, $timeout, $rootScope,
			weeklyLogItemService, pageTimingService,
			numberFormatService, $experiments, drilldownFunctionsService) {
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;

		$scope.$parent.$parent.showViewReport = true;

		$scope.slideshowView = $rootScope.slideshowView;

		updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged',
			'slideshowViewChanged', 'inventoryFilterChanged']);

		function getChart() {
			var columnDefinition = $scope.$parent.$parent.col;
			var curWidget = $scope.$parent.model;
			weeklyLogItemService.loadData()
				.then(
					function () {
						var results = weeklyLogItemService.getResultObj();
						$scope.chartData = results.data;
						$scope.empty = !$scope.chartData || !$scope.chartData.length;

						// calculate bgnum and delta
						if (!$scope.empty) {
							var lastPoint = $scope.chartData[$scope.chartData.length - 1];
							var lastValue = lastPoint.poCountInsideReceivingTime +
									lastPoint.poCountLateBucket1 +
									lastPoint.poCountLateBucket2 +
									lastPoint.poCountLateBucket3 +
									lastPoint.poCountLateBucket4;
							$scope.formattedBgNum = numberFormatService.getWithParameters(
								lastValue, 0);

							$scope.deltaValue = 0;
							$scope.formattedDelta = null;
							$scope.additionalDeltaText = null;
							if ($scope.chartData.length > 1) {
								var weeksBack = $scope.chartData.length >= 3 ? 3 : 2;
								var previousPoint = $scope.chartData[$scope.chartData.length - weeksBack];
								if (previousPoint.poCountInsideReceivingTime !== undefined) {
									var previousValue = previousPoint.poCountInsideReceivingTime +
											previousPoint.poCountLateBucket1 +
											previousPoint.poCountLateBucket2 +
											previousPoint.poCountLateBucket3 +
											previousPoint.poCountLateBucket4;
									$scope.deltaValue = lastValue - previousValue;
									$scope.formattedDelta = numberFormatService.getWithParameters(
										$scope.deltaValue, 0);
									$scope.status = ($scope.deltaValue > 0) ? 'bad' : 'good';
								}
							}
						}

						$scope.$broadcast('event:shortagePoActionsCtrl:getChart', null);
						pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					},
					function (e) {
						$scope.empty = true;
						$scope.chartData = [];
						$scope.$broadcast('event:shortagePoActionsCtrl:getChart', null);
						pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					}
				);
		}

		function loadData() {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));

				getChart();

				// set drilldown url
				var filterQueryParams = $scope.leanFilterService.getQueryParamsObject(true, true);
				filterQueryParams['drilldown'] = 1;
				filterQueryParams['factory'] = $scope.leanFilterService.getFactoryList();
				filterQueryParams['isMoveInForRequirement'] = [1];
				filterQueryParams['sort'] = 'analysisRequirementDate';
				filterQueryParams = _.omit(filterQueryParams, $scope.ignoreFilters);
				var url;
				var filters = [{id: 'responsibleNdx', values: []},{id: 'itemType', values: []}, {id: 'isMoveInForRequirement', values: [1]}];
				var sorters = [{ property: 'analysisRequirementDate', direction: 'ASC' }];
				url = 'home.html#/supply-chain/purchase-orders/' + drilldownFunctionsService.makeDrilldownParamString(filters, true, sorters);
				
				$scope.$parent.$parent.widget.drillDownUrl = url;
			} else {
				$timeout(loadData, 100);
			}
		}

		loadData();
	}
})();
